import { render, staticRenderFns } from "./HouseComment.vue?vue&type=template&id=88bbd338&"
import script from "./HouseComment.vue?vue&type=script&lang=js&"
export * from "./HouseComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports